import { Tree, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { FaEdit } from "react-icons/fa";
import Loader from 'components/loader';

const buildTreeData = (items, parentId = null) => {
  return items
    .filter((item) => item.parent_id === parentId)
    .map((item) => ({
      key: item.id,
      title: item.especialidad,
      tag: item.tag,
      children: buildTreeData(items, item.id),
    }));
};

const TableSpecialties = ({ isLoading, data, onEdit }) => {
  const [treeData, setTreeData] = useState([]);

  useEffect(() => {
    setTreeData(buildTreeData(data || []));
  }, [data]);

  const handleEdit = (id) => {
    const especialidadEdit = data.find((item) => item.id === id);
    if (onEdit) onEdit(especialidadEdit);
  };

  const titleRender = (node) => (
    <div className="flex w-full items-center justify-between gap-3 py-1 pr-2">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-navy-700 dark:text-white">{node.title}</span>
        {node.tag && <Tag color="blue">{node.tag}</Tag>}
      </div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleEdit(node.key);
        }}
        className="text-gray-400 transition duration-200 hover:text-brand-500"
        type="button"
      >
        <FaEdit />
      </button>
    </div>
  );

  return (
    <div className="w-full rounded-2xl border border-gray-100 bg-white p-5 shadow-sm dark:border-navy-700 dark:bg-navy-800">
      {isLoading ? (
        <Loader />
      ) : treeData.length === 0 ? (
        <p className="text-sm text-gray-600 dark:text-gray-400">No hay especialidades cargadas</p>
      ) : (
        <Tree
          treeData={treeData}
          titleRender={titleRender}
          defaultExpandAll
          showLine
          selectable={false}
          blockNode
        />
      )}
    </div>
  );
};

export default TableSpecialties;
